import {proposal} from './calculate-data/calculate-data--proposal';
import {popHealthDials} from './calculate-data/calculate-data--popHealthDials';

export const calculateDataHooks = {
  proposal,

  popHealthDials,
};
